var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.658,
    height: 14.656,
    viewBox: "0 0 14.658 14.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    d: "M-1374.362-2854.208h-4.35a1.573,1.573,0,0,1-1.662-1.66q0-4.358,0-8.715a1.572,1.572,0,0,1,1.661-1.661q3.434,0,6.869,0a.4.4,0,0,0,.312-.132q.971-.983,1.952-1.956a1.572,1.572,0,0,1,2.36,0q.494.489.983.983a1.57,1.57,0,0,1,0,2.337q-.987.99-1.979,1.975a.38.38,0,0,0-.121.3q0,3.458,0,6.916a1.556,1.556,0,0,1-1.175,1.558,1.977,1.977,0,0,1-.485.053Q-1372.179-2854.2-1374.362-2854.208Zm4.979-7.647c-.068.063-.111.1-.151.143q-1.949,1.948-3.9,3.892a1,1,0,0,1-.428.245c-1.21.321-2.423.628-3.636.936a.73.73,0,0,1-.258.027.527.527,0,0,1-.423-.744c.388-1.133.776-2.265,1.174-3.394a1.089,1.089,0,0,1,.245-.394q1.941-1.956,3.893-3.9c.041-.041.079-.084.144-.153h-5.994a.535.535,0,0,0-.609.613q0,4.358,0,8.714a.538.538,0,0,0,.61.613H-1370c.422,0,.616-.2.616-.623q0-2.894,0-5.788Zm-.49-4.615-5.854,5.852,1.765,1.767,5.854-5.853Zm-6.423,6.88-.587,1.707,1.826-.467Z",
    transform: "translate(1380.374 2868.863)",
    fill: "#9dacbd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTag);
export default __webpack_public_path__ + "static/media/edit-tag.5c50f2c033c9b65ad1571a9f5a4a62c4.svg";
export { ForwardRef as ReactComponent };